import { Link } from 'react-router-dom';

export default function RoomCard({ room }) {
    return (
        <div className="col-sm-12 col-md-6 my-3">
            <div className="card p-3 rounded bg-body-tertiary">
                <div id={room._id} className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active" data-bs-interval="5000">
                            <img className="img-fluid w-100" src={room.images[0].image} alt={room.name} height="550" width="550" />
                        </div>
                        <div className="carousel-item" data-bs-interval="5000">
                            <img className="img-fluid w-100" src={room.images[1].image} alt={room.name} height="550" width="550" />
                        </div>
                        <div className="carousel-item" data-bs-interval="5000">
                            <img className="img-fluid w-100" src={room.images[2].image} alt={room.name} height="550" width="550" />
                        </div>
                        <div className="carousel-item" data-bs-interval="5000">
                            <img className="img-fluid w-100" src={room.images[3].image} alt={room.name} height="550" width="550" />
                        </div>
                        <div className="carousel-item" data-bs-interval="5000">
                            <img className="img-fluid w-100" src={room.images[4].image} alt={room.name} height="550" width="550" />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target={`#${room._id}`}
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target={`#${room._id}`}
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
                {/* <img className="card-img-top mx-auto" src={room.images[0].image} alt={room.name}/> */}
                <div className="card-body d-flex flex-column justify-content-evenly align-items-center">
                    <h5 className="card-title">
                        <Link className=' text-black' to={"/room/" + room._id} >{room.name}</Link>
                    </h5>

                    <span className="d-inline-block text-truncate m-1" style={{ maxWidth: "300px", maxHeight: "100px" }}>
                        {room.description}
                    </span>

                    <div className="ratings m-3">
                        <div className="rating-outer">
                            <div className="rating-inner" style={{ width: `${room.ratings / 5 * 100}%` }} ></div>
                        </div>
                    </div>
                    <h5 className="card-text">Rs. {room.price}</h5>
                    <p className="card-text text-danger">{room.category}</p>
                    <Link to={"/room/" + room._id} className="btn btn-warning m-3">View Details</Link>
                </div>
            </div>
        </div>)
}